/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_TextInputs */

const en_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match by Text`)
};

const fr_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondance par texte`)
};

const de_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übereinstimmung per Text`)
};

const it_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrispondenza tramite testo`)
};

const ru_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совпадение по тексту`)
};

const es_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencia por texto`)
};

const zh_cn2_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本匹配`)
};

const ja_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストで一致`)
};

const hi_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट द्वारा मिलान करें`)
};

const pt_pt2_metadata_merge_match_by_text = /** @type {(inputs: Metadata_Merge_Match_By_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondência por texto`)
};

/**
* | output |
* | --- |
* | "Match by Text" |
*
* @param {Metadata_Merge_Match_By_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_text = /** @type {((inputs?: Metadata_Merge_Match_By_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_match_by_text(inputs)
	if (locale === "de") return de_metadata_merge_match_by_text(inputs)
	if (locale === "it") return it_metadata_merge_match_by_text(inputs)
	if (locale === "ru") return ru_metadata_merge_match_by_text(inputs)
	if (locale === "es") return es_metadata_merge_match_by_text(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_match_by_text(inputs)
	if (locale === "ja") return ja_metadata_merge_match_by_text(inputs)
	if (locale === "hi") return hi_metadata_merge_match_by_text(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_match_by_text(inputs)
	return en_metadata_merge_match_by_text(inputs)
});